module.exports = __webpack_public_path__ + "img/latest_ja_fp_logo.c98d9b74.svg";